import type {
  CreateWebsiteInput,
  UpdateWebsiteInput,
  WebsiteDTO,
  WebsiteWithSnippet,
} from '@bruno/shared';
import { api } from './client';

export const listWebsites = () =>
  api<{ websites: WebsiteDTO[] }>('/v1/websites');

export const getWebsite = (id: string) => api<WebsiteWithSnippet>(`/v1/websites/${id}`);

export const createWebsite = (input: CreateWebsiteInput) =>
  api<WebsiteWithSnippet>('/v1/websites', { method: 'POST', body: input });

export const updateWebsite = (id: string, input: UpdateWebsiteInput) =>
  api<WebsiteWithSnippet>(`/v1/websites/${id}`, { method: 'PATCH', body: input });

export const deleteWebsite = (id: string) =>
  api<void>(`/v1/websites/${id}`, { method: 'DELETE' });

export const rotateEmbedKey = (id: string) =>
  api<WebsiteWithSnippet>(`/v1/websites/${id}/rotate-key`, { method: 'POST' });
